// extracted by mini-css-extract-plugin
export default {"topBanner":"TopBanner_topBanner__mbNVk","counter":"TopBanner_counter__SnqVk"};